import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    class: "flex flex-col gap-3 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-(--colors-background-white) p-4 shadow-(--blur-shadow-s)",
    "data-testid": "consent-address-card"
};
const _hoisted_2 = { class: "flex flex-col gap-2" };
const _hoisted_3 = { class: "flex flex-wrap items-center gap-1.5" };
const _hoisted_4 = { class: "flex flex-col gap-0.5" };
const _hoisted_5 = ["title"];
const _hoisted_6 = {
    key: 0,
    class: "flex list-none flex-wrap gap-1.5 p-0"
};
const _hoisted_7 = {
    class: "sr-only",
    "data-testid": "consent-purpose-status"
};
const _hoisted_8 = {
    key: 0,
    "data-testid": "consent-card-actions"
};
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Badge, IconShape } from "@eudonet/opal";
import { CONSENT_ADDRESS_TYPE_ICON, CONSENT_STATUS_THEME, DISPLAYED_STATUS_ICON, } from "@/modules/consent/domain/entities/consentOverview";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConsentAddressCard',
    props: {
        address: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        // The design ships an envelope on every card, including the phone one. That is a designer
        // oversight, not an instruction: the icon follows the address type, matching what the shipped
        // consents tab already renders off the same data.
        const addressIcon = computed(() => CONSENT_ADDRESS_TYPE_ICON[props.address.addressType]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("article", _hoisted_1, [
                _createVNode(_unref(IconShape), {
                    size: "md",
                    type: "square",
                    variant: "outlined",
                    color: "white",
                    icon: addressIcon.value
                }, null, 8 /* PROPS */, ["icon"]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(Badge), {
                            type: "with-dot",
                            theme: "dark",
                            size: "lg",
                            label: _unref(t)(__props.address.labelKey),
                            "show-left-icon": false,
                            "data-testid": "consent-qualifier-badge"
                        }, null, 8 /* PROPS */, ["label"]),
                        (__props.address.isPrimary)
                            ? (_openBlock(), _createBlock(_unref(Badge), {
                                key: 0,
                                theme: "yellow",
                                size: "sm",
                                label: _unref(t)('contact.detail.consentsWidget.primary'),
                                "show-close-icon": false,
                                "data-testid": "consent-primary-badge",
                                "left-icon": "ri-star-line"
                            }, null, 8 /* PROPS */, ["label"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h4", {
                            class: "truncate text-base leading-5 font-bold text-(--text-text-heading)",
                            title: __props.address.value,
                            "data-testid": "consent-address-value"
                        }, _toDisplayString(__props.address.value), 9 /* TEXT, PROPS */, _hoisted_5),
                        (__props.address.purposes.length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.address.purposes, (purpose) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: purpose.code
                                    }, [
                                        _createVNode(_unref(Badge), {
                                            label: purpose.label,
                                            theme: _unref(CONSENT_STATUS_THEME)[purpose.status],
                                            size: "xs",
                                            "show-close-icon": false,
                                            truncate: "",
                                            "data-testid": "consent-purpose-badge",
                                            "left-icon": _unref(DISPLAYED_STATUS_ICON)[purpose.status]
                                        }, null, 8 /* PROPS */, ["label", "theme", "left-icon"]),
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)(`contact.detail.consents.status.${purpose.status}`)), 1 /* TEXT */)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                (_ctx.$slots.actions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _renderSlot(_ctx.$slots, "actions")
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
